import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RefreshCw } from 'lucide-angular';
import { Banner } from '../../ui/banner/banner';
import { VersionUpdateService } from '../../../services/version-update/version-update.service';

// App-wide prompt shown when the service worker has fetched a new build. PWA
// caching can otherwise keep users on a stale version until they hard-refresh;
// the CTA activates the new version and reloads the page.
@Component({
  selector: 'skk-version-banner',
  imports: [Banner],
  templateUrl: './version-banner.html',
  styleUrl: './version-banner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionBanner {
  private readonly versionUpdate = inject(VersionUpdateService);

  readonly RefreshIcon = RefreshCw;
  readonly show = this.versionUpdate.updateReady;
  readonly isLoading = signal(false);

  reload(): void {
    this.isLoading.set(true);
    void this.versionUpdate.reload();
  }
}
